import React from 'react'

import { toSafeHttpUrl } from '@/lib/helpers/helperFunctions'

interface Props {
  company: {
    presentationName: string
    privacyPolicyUrl: string
  }
}

const AgreeToCompanyPrivacyPolicyLabel: React.FC<Props> = ({ company }) => {
  return (
    <>
      I have read and agree to {company.presentationName}'s{' '}
      <a
        href={toSafeHttpUrl(company.privacyPolicyUrl) ?? undefined}
        target="_blank"
        rel="noreferrer"
      >
        Privacy Policy
      </a>
    </>
  )
}

export default AgreeToCompanyPrivacyPolicyLabel
